
import img1 from "../../../../assets/img/Services/StrategicConsulting/126.jpg"

import { AiOutlineRobot } from "react-icons/ai"
import { RiContractLine } from "react-icons/ri"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Adoption & Advocacy
            </h1>
            <p className="text-lg text-gray-600">
            Promote blockchain technologies like smart contracts, supply chain transparency, and tokenization for business use cases.
			      </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineRobot className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Supply Chain Transparency</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Enhance trust and traceability in supply chains.
			                </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <RiContractLine className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Empower Smart Contracts
                </h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Facilitate secure, automated agreements for businesses.
              </p>
            </div>


          </div>
        </div>

      
      </div>
    </div>
  )
}